const Moment = require('moment');

exports.hasSortableLastMessage = (lastMessage, isSortableLastMessage = () => true) => {

    return !!lastMessage?.timestamp &&
        Moment(lastMessage.timestamp).isValid() &&
        isSortableLastMessage(lastMessage);
};

exports.sortByLatestMessage = ({
    items,
    getLastMessage = (item) => item?.lastMessage,
    sortByName,
    isSortableLastMessage
}) => {

    return (items || []).sort((item1, item2) => {

        const lastMessage1 = getLastMessage(item1);
        const lastMessage2 = getLastMessage(item2);
        const hasLastMessage1 = exports.hasSortableLastMessage(lastMessage1, isSortableLastMessage);
        const hasLastMessage2 = exports.hasSortableLastMessage(lastMessage2, isSortableLastMessage);

        if (!hasLastMessage1 && !hasLastMessage2) {
            return sortByName(item1, item2);
        }

        if (!hasLastMessage1) {
            return 1;
        }

        if (!hasLastMessage2) {
            return -1;
        }

        if (Moment(lastMessage1.timestamp).isSame(Moment(lastMessage2.timestamp))) {
            return sortByName(item1, item2);
        }

        return Moment(lastMessage1.timestamp).isBefore(Moment(lastMessage2.timestamp)) ? 1 : -1;
    });
};
